import React from "react";

export function About() {
  return (
    <section className="about-section container mb-1" style={{ minHeight: "60vh" }}>
      <h2 className="mb-4" style={{ color: "#00ffff" }}>About Me</h2>
      <p style={{ color: "#f5f5f5", maxWidth: "700px" }}>
        Hi! I’m Maanas Menghani, a passionate and asipiring game developer with a strong foundation in Unity and C#. I love bringing ideas to life by creating engaging and immersive gameplay experiences.
      </p>
      <p style={{ color: "#aaaaaa", maxWidth: "700px" }}>
        My interest in video games began during my school years, where titles such as Super Mario Maker inspired me to explore the creative process behind game development. This early curiosity motivated me to learn how interactive experiences are designed and brought to life.
      </p>
      <p style={{ color: "#f5f5f5", maxWidth: "700px" }}>
        During college, I strengthened my foundations by developing a variety of small-scale programming projects, including several Unity-based games that allowed me to apply core concepts in practice.
      </p>
      <p style={{ color: "#f5f5f5", maxWidth: "700px" }}>
        I enjoy collaborating with creative teams to build fun, polished games and am always eager to learn new technologies and techniques. When I’m not coding, I like exploring new games, experimenting with design, and research about letest trends.
      </p>
      <p style={{ color: "#aaaaaa", maxWidth: "700px" }}>
        I’m excited to contribute my skills and enthusiasm to innovative projects and grow as a developer.
      </p>
    </section>
  );
}